exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".results-table {\n  width: 100%;\n  min-width: 1200px;\n  max-height: 700px;\n  overflow: auto; }\n\n.mat-dialog-content {\n  max-height: 70vh;\n  overflow: auto; }\n\n.invoice-link {\n  color: #2196f3;\n  text-decoration: none;\n  cursor: pointer; }\n  .invoice-link:hover {\n    text-decoration: underline; }\n\n.matching-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/DocumentsModule/DocumentPaymentsResultsDialogComponent/document-payments-results.dialog.component.scss
// module id = ../../../../../src/DocumentsModule/DocumentPaymentsResultsDialogComponent/document-payments-results.dialog.component.scss
// module chunks = main